import React, { Component } from "react";
import PropTypes from "prop-types";
import { Base64 } from "js-base64";
import { isMobile, isIOS, isAndroid, isChrome, isChromium } from "react-device-detect";
import Logo from "../../assets/img/xoicon2022.png";
import AppleBadge from "../../assets/img/App_Store_Badge_Black.svg";
import GoogleBadge from "../../assets/img/google-play-badge.png";

import Loader from "../ui/Loader";

class XOLinker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			bundleId: "",
			scheme: "",
			payload: "",
		};
		this.uploadButton = React.createRef();
	}

	componentDidMount() {
		const { match } = this.props;
		const { params } = match;
		const { linkId } = params;
		// const payload = {
		// 	integration: "5c642cad2289f810482d0713",
		// };

		//DFL
		// const linkData = {
		// 	experienceId: "5c51f70446b8bd4c607d8e5a",
		// 	pageId: "5d924b0d796e133d24a98f67",
		// };

		//Prestonwood
		// const linkData = {
		// 	experienceId: "5d64406b5ff2e70e00efdeec",
		// 	pageId: "5d7a78e128a5d112ece1598b",
		// };

		const linkData = {
			integrationKey: "@hillsong-technology/verris-integration-brushfire-identity",
		};

		var search = window.location.search.substring(1);
		const urlParams = search
			? JSON.parse(
					'{"' +
						decodeURI(search)
							.replace(/"/g, '\\"')
							.replace(/&/g, '","')
							.replace(/=/g, '":"') +
						'"}'
			  )
			: {};
		const payloadObject = Object.assign({}, urlParams, linkData);
		console.log(payloadObject);
		const payload = Base64.encode(JSON.stringify(payloadObject));

		const bundleId = "com.marriagetoday.xo";
		const scheme = "verris10191";
		// if (isMobile) {
		// 	if (isIOS) {
		// 		setTimeout(() => {
		// 			//window.location = "https://apps.apple.com/us/app/xo-marriage/id1491824919";
		// 			this.setLink(bundleId, payload, scheme);
		// 		}, 1000);
		// 		window.location = `${scheme}://payload/${payload}`;
		// 	} else if (isAndroid) {
		// 		if (isChrome || isChromium) {
		// 			//window.location = `verris10191://payload/${link}`;
		// 			//window.location = `intent://payload/${link}#Intent;scheme=verris10191;package=${bundleId};end`;
		// 			// setTimeout(function() {
		// 			// 	window.inputElement.click();
		// 			// }, 250);
		// 			//window.location = `https://verris.page.link/?link=https://www.example.com/someresource&apn=${bundleId}&ibi=${bundleId}&isi=1234567&ius=${scheme}`;

		// 			window.location = `${scheme}://payload/${payload}`;
		// 			setTimeout(() => {
		// 				this.setLink(bundleId, payload, scheme);
		// 			}, 1000);
		// 		} else {
		// 			window.location = `${scheme}://payload/${payload}`;
		// 			setTimeout(function() {
		// 				window.location = `https://play.google.com/store/apps/details?id=${bundleId}`;
		// 			}, 1000);
		// 		}
		// 	} else {
		// 		this.setLink(bundleId, payload, scheme);
		// 	}
		// } else {
		// 	//TODO Display phones and buttons
		this.setLink(bundleId, payload, scheme);
		// }
	}
	setLink = (bundleId, payload, scheme) => {
		this.setState({ isLoading: false, bundleId, payload, scheme });
	};

	renderLinks = () => {
		const { bundleId, payload, scheme } = this.state;

		if (isMobile) {
			if (isIOS) {
				return (
					<div>
						<h2>{"The official app for XO Marriage conferences and events"}</h2>
						<p>
							Find all the essential event info in one place: Conference Schedule, Live Updates, Speaker
							Notes, Site Map, and more!
						</p>
						<br />
						<div className="divider">
							<b style={{ textAlign: "left" }}>Step 1:</b>
						</div>
						<a href="https://apps.apple.com/us/app/xo-marriage/id1491824919">
							<img src={AppleBadge} />
						</a>
						<br />
						<div className="divider">
							<b style={{ textAlign: "left" }}>Step 2:</b>
						</div>
						<br />
						<a className="btn btn-primary" href={`${scheme}://payload/${payload}`}>
							Add Tickets to Wallet
						</a>
					</div>
				);
			} else if (isAndroid) {
				if (isChrome || isChromium) {
					return (
						<div>
							<h2>{"The official app for XO Marriage conferences and events"}</h2>
							<p>
								Find all the essential event info in one place: Conference Schedule, Live Updates,
								Speaker Notes, Site Map, and more!
							</p>
							<br />
							<a
								className="btn"
								href={`intent://verris/payload/${payload}#Intent;scheme=${scheme};package=${bundleId};end`}
							>
								Add Tickets to Wallet
							</a>
						</div>
					);
				}
			}
		}

		return (
			<div>
				<h2>{"The official app for XO Marriage conferences and events"}</h2>
				<p>
					Find all the essential event info in one place: Conference Schedule, Live Updates, Speaker Notes,
					Site Map, and more!
				</p>
				<br />
				<div className="divider">
					<b style={{ textAlign: "left" }}>Step 1:</b>
				</div>
				<a href="https://apps.apple.com/us/app/xo-marriage/id1491824919">
					<img src={AppleBadge} />
				</a>
				<a href={`https://play.google.com/store/apps/details?id=${bundleId}`}>
					<img src={GoogleBadge} style={{ maxHeight: "60px" }} />
				</a>
				<br />
				<div className="divider">
					<b style={{ textAlign: "left" }}>Step 2:</b>
				</div>
				<br />
				<a className="btn btn-primary" href={`${scheme}://payload/${payload}`}>
					Add Tickets to Wallet
				</a>
			</div>
		);
	};

	render() {
		const { isLoading, bundleId, payload, scheme } = this.state;
		if (isLoading) {
			return (
				<div className="absolute-center ta-center">
					<Loader />
				</div>
			);
		}
		return (
			<div className="xo-background">
				<div className="absolute-center ta-center" style={{ width: "100%", padding: "10px" }}>
					<img
						src={Logo}
						alt="logo"
						style={{ maxWidth: "200px", width: "100%", marginBottom: "20px", borderRadius: "100px" }}
					/>
					<br />
					<div className="box">{this.renderLinks()}</div>
				</div>
			</div>
		);
	}
}

XOLinker.propTypes = {
	match: PropTypes.object,
};

export default XOLinker;
